import { Flex, Text } from "@radix-ui/themes";

import { ChevronNavButton } from "./ChevronNavButton";

export type ReviewNavStripProps = {
  reviewIndex: number;
  totalReviews: number;
  onPrevReview?: () => void;
  onNextReview?: () => void;
};

/**
 * Sequential review navigation ("Review N of M") shared by the artwork pane
 * in 3-pane multi-review chats and the TicketViewPane in 2-pane drill-ins.
 */
export function ReviewNavStrip({
  reviewIndex,
  totalReviews,
  onPrevReview,
  onNextReview,
}: ReviewNavStripProps) {
  if (totalReviews <= 1) return null;

  return (
    <Flex
      align="center"
      justify="center"
      gap="2"
      className="shrink-0 border-b border-puntt-neutral-gray-5 bg-puntt-neutral-gray-2 px-3 py-1.5"
      data-testid="review-nav-strip"
    >
      <ChevronNavButton
        direction="left"
        onClick={onPrevReview}
        disabled={reviewIndex === 0}
        aria-label="Previous review"
        data-testid="review-nav-prev"
      />
      <Text
        size="1"
        className="text-puntt-neutral-gray-11"
        data-testid="ticket-view-review-label"
      >
        Review {reviewIndex + 1} of {totalReviews}
      </Text>
      <ChevronNavButton
        direction="right"
        onClick={onNextReview}
        disabled={reviewIndex === totalReviews - 1}
        aria-label="Next review"
        data-testid="review-nav-next"
      />
    </Flex>
  );
}
